module.exports = __webpack_public_path__ + "img/img_hdbm.11ec8ab0.png";